export const ZOOM_EVENT_TYPES = [
  "endpoint.url_validation",
  "session.alert",
  "session.ended",
  "session.started",
  "session.user_joined",
  "session.user_left",
] as const;
